import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { CloseIcon } from '~web/view/components/ui/icon/close-icon.component';
import { Span } from '~common/components/span.component';

export interface Props {
  successText: string;
  onClose?: () => void;
}

export const SuccessMessage: React.FunctionComponent<Props> = ({
  successText,
  onClose,
  ...renderProps
}) => {
  const [isOpened, setOpened] = useState(true);

  const handleClose = (): void => {
    setOpened(false);

    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    setOpened(true);
  }, [successText]);

  return (
    isOpened && (
      <Container {...renderProps}>
        <Content>
          <StyledText>{successText}</StyledText>
        </Content>
        <CloseIconWithMargin onClick={handleClose} />
      </Container>
    )
  );
};

const Container = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: ${(props): number => props.theme.zIndex.success};
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 25px;
  background-color: ${(props): string => props.theme.colors.green};
`;

const Content = styled(Column)`
  flex: 1;
`;

const StyledText = styled(Span)`
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.3px;
  white-space: pre-wrap;
`;

const CloseIconWithMargin = styled(CloseIcon)`
  margin-left: 24px;
`;



// WEBPACK FOOTER //
// ./view/components/ui/success-message.component.tsx